import request from '@/utils/request'

// 查询企业登记信息与服务机构信息
export function queryDetail(query) {
  return request({
    url: '/web/qydjxx/queryDetail',
    method: 'get',
    params: query
  })
}

//查询服务机构类型
export function queryFwjgLx(query) {
  return request({
    url: '/web/qydjxx/queryFwjgLx',
    method: 'get'
  })
}

//更新服务机构信息
export function updateJgfw(data) {
    return request({
        url: '/web/qydjxx/edit',

        method: 'post',
        data: data
    })
}

